import { CSSProperties, useState } from 'react';
import { ButtonView } from '@vivli/shared/views';
import { first } from 'rxjs/operators';
import { IResultRequest } from '@vivli/features/results-request/infrastructure/interface';
import { useModalApiContext, useResultRequestApiContext } from '@vivli/core/infrastructure/context';

const buttonContainerStyle: CSSProperties = {
    width: '100%',
    display: 'grid',
    gridTemplateRows: '1fr auto',
    marginBottom: '10px',
};

interface CreateResultRequestButtonViewProps {
    onCreatingResultRequest?: () => void;
    onResultRequestCreated?: (resultRequest: IResultRequest) => void;
    requestId: string;
}

export const CreateResultRequestButtonView = ({
    onCreatingResultRequest,
    onResultRequestCreated,
    requestId,
}: CreateResultRequestButtonViewProps) => {
    const resultRequestService = useResultRequestApiContext();
    const modal = useModalApiContext();
    const [isLoading, setIsLoading] = useState(false);

    const createResultRequest = () => {
        onCreatingResultRequest && onCreatingResultRequest();
        setIsLoading(true);
        resultRequestService
            .createResultRequest(requestId)
            .pipe(first())
            .subscribe((result) => {
                onResultRequestCreated && onResultRequestCreated(result);
                setIsLoading(false);
            });
    };

    const createResultRequestConfirm = () => {
        modal.confirm('Create New Result Request?', {
            confirmText: 'Yes',
            cancelText: 'No',
            onConfirm: createResultRequest,
        });
    };

    return (
        <div style={buttonContainerStyle}>
            <ButtonView onClick={createResultRequestConfirm} style={{ float: 'right', maxWidth: 300 }} isLoading={isLoading}>
                Create New Results Request
            </ButtonView>
        </div>
    );
};
